import { getAPI } from 'src/utils/api';
import { notification } from 'antd';
import i18n from 'i18next';
import checkAuthError from '../utils/checkAuthError';

notification.config({
	placement: 'topRight',
	top: 75,
	duration: 2,
});

const getSettings = async (settingsName) => {
	try {
		const api = await getAPI();
		const { data } = await api.get('/settings/' + settingsName);
		return data;
	} catch (error) {
		checkAuthError(error);
	}
};

const setSettings = async (settingsName, values) => {
	try {
		const api = await getAPI();
		const { data } = await api.post('/settings/' + settingsName, values);
		if (data.error) {
			throw new Error(data.error);
		}
		notification.success({
			message: i18n.t('mainSettings.saveSuccess'),
		});
		return data;
	} catch (error) {
		checkAuthError(error);
		notification.error({
			message: i18n.t('notifications.onSaveError'),
			description: error.message,
		});
		console.error(error);
	}
};

const sendTestMail = async (settings) => {
	try {
		const api = await getAPI();
		const { data } = await api.post('/settings/emailSettings/sendTest', settings);
		return data;
	} catch (error) {
		checkAuthError(error);
		console.error(error);
		return { success: false, error: error.message };
	}
};

export { getSettings, setSettings, sendTestMail };
